import { STATEMENT_SCOPE } from "../../../constants/statements";
import { StatementsFilterGroup, StatementsFilters } from "../types/statements-filter";

import { STATEMENT_STATUS } from "./statements";

/** Why the status groups are inert while the Deleted view is on. */
export const DELETED_VIEW_STATUS_LABEL = "Deleted statements have no billing status to filter by";

export const ARCHIVE_STATUS = {
  Archived: "Archived",
} as const;

/**
 * The checkbox value for the Deleted view. It reuses the search scope token rather than the literal
 * word: the Cancelled badge status renders as "Deleted" too, so a literal value would be read back
 * out of the selection as a status filter instead of the scope it means.
 */
export const DELETED_VIEW_VALUE = STATEMENT_SCOPE.DeletedOnly;

export const EMPTY_STATEMENTS_FILTERS: StatementsFilters = {
  statuses: [],
  archived: false,
  deleted: false,
};

export const STATEMENTS_FILTER_GROUPS: StatementsFilterGroup[] = [
  {
    title: "By Statement Status",
    isStatusGroup: true,
    options: [
      { value: STATEMENT_STATUS.Unsent, label: STATEMENT_STATUS.Unsent },
      { value: STATEMENT_STATUS.Sent, label: STATEMENT_STATUS.Sent },
      { value: STATEMENT_STATUS.Accepted, label: STATEMENT_STATUS.Accepted },
      { value: STATEMENT_STATUS.Rejected, label: STATEMENT_STATUS.Rejected },
    ],
  },
  {
    title: "Payment Status",
    isStatusGroup: true,
    options: [
      { value: STATEMENT_STATUS.Processing, label: STATEMENT_STATUS.Processing },
      { value: STATEMENT_STATUS.Paid, label: STATEMENT_STATUS.Paid },
      { value: STATEMENT_STATUS.Denied, label: STATEMENT_STATUS.Denied },
    ],
  },
  {
    title: "Archive or Deleted",
    options: [
      { value: DELETED_VIEW_VALUE, label: "Deleted" },
      { value: ARCHIVE_STATUS.Archived, label: ARCHIVE_STATUS.Archived },
    ],
  },
];
